import { O365Entra } from "./O365Entra"
import { O365Exchange } from "./O365Exchange"
import { O365Graph } from "./O365Graph"

export const O365InfoTable = () =>{
    return (
        <div>
            <div style={{width: "100%", display: "inline-block", float: "left", position: "relative"}}>
                <div className="container-div">
                  <O365Entra />
                </div>
                <div className="container-div">
                  <O365Exchange />
                </div>
                <div className="container-div">
                  <O365Graph />
                </div>
            </div> 
        </div>
    )
}